export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10920.af6cb5bf.jpg";